import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(null);

  // Initialize state from localStorage once on app load
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setUserDetails(JSON.parse(user));
    }
  }, []);

  // Function to update user details and localStorage
  const updateUser = (newDetails) => {
    setUserDetails(newDetails);
    localStorage.setItem('user', JSON.stringify(newDetails));
    console.log(" updated user details", localStorage.getItem('user'))
    console.log(" updated role", localStorage.getItem('role'))
  };

  return (
    <UserContext.Provider value={{ userDetails, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to easily access the context
export const useUser = () => {
  const context = useContext(UserContext);
  // {console.log("This is user profile of useUser", localStorage.getItem('user'))}
  // {console.log("This is role of useUser", localStorage.getItem('role'))}
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};